import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Dashed grey placeholder frame; a direct-child icon becomes the large muted glyph of an empty state. */
export const DashedPanel = styled(Stack, {
  shouldForwardProp: prop => prop !== 'thickness',
})<{ thickness?: 1 | 2 }>(({ theme, thickness = 2 }) => ({
  border: `${thickness}px dashed`,
  borderColor: theme.palette.grey[300],
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.grey[50],
  '& > .MuiSvgIcon-root': {
    fontSize: 48,
    color: theme.palette.grey[400],
    marginBottom: theme.spacing(2),
  },
}));
